import script from "./ReviewCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewCard.vue?vue&type=script&setup=true&lang=ts"

import "./ReviewCard.vue?vue&type=style&index=0&id=d0104e7c&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0104e7c"]])

export default __exports__